export default __webpack_public_path__ + "static/media/4.f1c6915f.webp";